// "The app has its first screen ready" (F179), for the launch screen. /app's
// home calls markAppReady once the account and its first data are in; other
// /app pages once the account check is done (AuthProvider). Idempotent.

const EVENT = "shemshop:app-ready";
let ready = false;

export function markAppReady() {
  if (ready) return;
  ready = true;
  window.dispatchEvent(new Event(EVENT));
}

/** Calls `fn` once the app is ready (right away if it already is); returns an unsubscribe. */
export function onAppReady(fn: () => void): () => void {
  if (ready) {
    fn();
    return () => {};
  }
  const handler = () => fn();
  window.addEventListener(EVENT, handler, { once: true });
  return () => window.removeEventListener(EVENT, handler);
}
